module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    ref: "permitsduetable",
    attrs: {
      "table-ref": "permitsduetable",
      "title": "Permits",
      "icon": "fa fa-list",
      "hide-org-badge": "",
      "show-search": false,
      "url": '/permits/site/' + _vm.rowData.id,
      "fields": _vm.fields
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-530d9602"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/calendar/Permits.vue
// module id = 1488
// module chunks = 0